export const TEMPLATE_VAR_FULL = /^\{\{[^{}]+\}\}$/

export const isTemplateToken = (value: unknown): value is string => {
  return typeof value === 'string' && TEMPLATE_VAR_FULL.test(value)
}
